"use client";

import { c as _c } from "react/compiler-runtime";
import type { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
import { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import React, { useMemo } from "react";
interface WaveleaderboardSortProps {
  readonly sort: WaveDropsLeaderboardSort;
  readonly onSortChange: (sort: WaveDropsLeaderboardSort) => void;
}
export const WaveleaderboardSort: React.FC<WaveleaderboardSortProps> = t0 => {
  const $ = _c(4);
  const {
    sort,
    onSortChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      key: WaveDropsLeaderboardSort.RANK,
      label: "Current Vote",
      value: WaveDropsLeaderboardSort.RANK
    }, {
      key: WaveDropsLeaderboardSort.RATING_PREDICTION,
      label: "Projected Vote",
      value: WaveDropsLeaderboardSort.RATING_PREDICTION
    }, {
      key: WaveDropsLeaderboardSort.TREND,
      label: "Hot",
      value: WaveDropsLeaderboardSort.TREND
    }, {
      key: WaveDropsLeaderboardSort.CREATED_AT,
      label: "Newest",
      value: WaveDropsLeaderboardSort.CREATED_AT
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const sortItems = t1;
  let t2;
  if ($[1] !== onSortChange || $[2] !== sort) {
    t2 = <div className="tw-min-w-0"><CommonDropdown items={sortItems} activeItem={sort} filterLabel="Sort" setSelected={onSortChange} size="sm" showFilterLabel={true} /></div>;
    $[1] = onSortChange;
    $[2] = sort;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};